if (!global._babelPolyfill) {
    require('babel-polyfill')
};

import React from "react";
import { connect } from "react-redux";

import * as actionTypes from "../actions/actionTypes";
let actions = require("../actions/actions");

export class SuspendCreatorModal extends React.Component {
    checkForError(error) {
        let errorClass = "", errorReason = null;

        if (error) {
            errorClass = "error";
            errorReason = (
                <span className="errorReason">{"A reason in required"}</span>
            );
        }

        return {
            class: errorClass,
            reason: errorReason
        };
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.result.actionType === actionTypes.SUSPEND_CREATOR_SUCCESS
        ) {
            if (this.props.referringComponent === "Moderation") {
                // modal was fired from the moderation tool
                this.props.fetchUploadIcons("");
            }

            // dismiss modal
            this.props.dismissModal();
        }
    }

    constructor(props) {
        super(props);

        this.state = {
            errorSupplyingReason: false
        };
    }

    dismissModal(e) {
        if (e) e.preventDefault();

        this.props.dismissModal();
    }

    render() {
        let error = this.checkForError(this.state.errorSupplyingReason);

        return (
            <div
                className={
                    "react-modal full-transparent moderation-modal-background suspend-creator-modal"
                }
            >
                <a
                    href="#"
                    className="modal-background-closer"
                    onClick={this.dismissModal.bind(this)}
                />
                <div className={"inner-modal"}>
                    <a
                        href="#"
                        onClick={this.dismissModal.bind(this)}
                        title="close"
                        className="ui_close"
                    />
                    <div
                        className="modal-content"
                        style={{ background: "white" }}
                    >
                        <div className="suspend-user-flag ui_flag red" />
                        <h3 className="modal-title">
                            {"Suspend Creator for Investigation"}
                        </h3>
                        <p className="gray">
                            {
                                "To suspend this creator, you must add a note as to why they need to be investigated"
                            }
                        </p>
                        <form className="new-form">
                            <label>
                                <textarea
                                    ref={"suspendReason"}
                                    className={`gray ${error.class}`}
                                    placeholder="Write something here..."
                                />
                                {error.reason}
                            </label>
                        </form>
                        <button
                            className="btn btn-default red"
                            onClick={this.suspendCreator.bind(this)}
                        >
                            {"Suspend Creator"}
                        </button>
                        <div className="cancel-btn">
                            <a
                                className="text-link"
                                onClick={this.dismissModal.bind(this)}
                            >
                                {"Cancel"}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    suspendCreator() {
        if (!this.refs.suspendReason.value) {
            this.setState({ errorSupplyingReason: true });
        } else {
            this.props.suspendCreator(
                this.props.creator.id,
                this.refs["suspendReason"].value
            );
        }
    }
}

export default connect(null, {
    fetchUploadIcons: actions.fetchUploadIcons,
    suspendCreator: actions.suspendCreator
})(SuspendCreatorModal);
